module.exports = __webpack_public_path__ + "components/MapControl/svg/Szlak przyrodniczo-edukacyjny czarny.svg?63aa9b17";


//////////////////
// WEBPACK FOOTER
// ./components/MapControl/svg/Szlak przyrodniczo-edukacyjny czarny.svg
// module id = 2089
// module chunks = 0